import { createFileRoute } from '@tanstack/react-router';

import { ApiKeysManager } from '@/features/api-key/components/api-keys-manager';

export const Route = createFileRoute('/_authed/')({
  component: () => <ApiKeysManager className="mb-20 max-w-full" />,
});
